import styles from './Modal.css'
import {Modal} from 'react-bootstrap'

class ModalHeader extends React.Component {
  render () {
    return (<Modal.Header>
      <Modal.Title bsClass={`modal-title ${styles['modal-title']}`}>{this.props.title}</Modal.Title>
    </Modal.Header>)
  }
}

ModalHeader.propTypes = {
  title: React.PropTypes.string
}

export default ModalHeader



// WEBPACK FOOTER //
// ./app/components/Modal/ModalHeader.js